import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
@Entity('employment_type')
export class EmploymentType {

  @PrimaryGeneratedColumn("increment",{name:'emp_type_id'})
  empTypeId:number;
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"employment_type"
      })
  employmentType:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
    })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: false,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
}
